module.exports = __webpack_public_path__ + "assets/img/202112-2W.121906cd.png";